import React from 'react'
// import Prescription from '../Components/MedicalImagesUpload/Prescription'
import LabReports from '../Components/MedicalImagesUpload/LabReports'

const imageuploadview = () => {
  return (
    <div>
      <LabReports />
      </div>
  )
}

export default imageuploadview